import React from "react";
import { BlueprintDescriptionPopover } from "@components/molecules/blueprint-description-popover/blueprint-description-popover";

export const renderBlueprintPopover = (
  activePopover,
  popoverPosition,
  handleCloseDescriptionPopover,
) => {
  return activePopover && activePopover.name ? (
    <BlueprintDescriptionPopover
      blueprint={activePopover}
      renderPosition={popoverPosition}
      handleClosePopover={handleCloseDescriptionPopover}
    />
  ) : (
    <></>
  );
};
